var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { Container } from "./styled/subject-property-marker";

function SubjectPropertyMarker(_a) {
  var _b = _a.offsetX,
      offsetX = _b === void 0 ? 0 : _b,
      _c = _a.offsetY,
      offsetY = _c === void 0 ? -7 : _c,
      _d = _a.includeHouse,
      includeHouse = _d === void 0 ? true : _d,
      props = __rest(_a, ["offsetX", "offsetY", "includeHouse"]);

  var id = Math.random().toString(16).substr(2);
  return React.createElement(Container, __assign({
    offsetX: offsetX,
    offsetY: offsetY
  }, props), React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 38"
  }, React.createElement("ellipse", {
    cx: "13",
    cy: "32",
    rx: "12",
    ry: "6",
    fill: "url(#icon-marker-subject-property-" + id + ")"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 12.2C26 5.461 20.18 0 13 0S0 5.462 0 12.2c0 .004.013.007.015.012.01 6.605 9.532 16.723 12.264 19.49a1.027 1.027 0 001.448 0c2.732-2.768 12.265-12.894 12.265-19.501h-.004l.012-.002z"
  }), includeHouse && React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.561 6.165a.667.667 0 01.878 0l5.333 4.667c.145.126.228.31.228.501v6a.667.667 0 01-.667.667H7.667A.667.667 0 017 17.333v-6c0-.192.083-.375.228-.501l5.333-4.667z",
    fill: "#fff"
  }), React.createElement("defs", null, React.createElement("radialGradient", {
    id: "icon-marker-subject-property-" + id,
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 6 -12 0 13 32)"
  }, React.createElement("stop", {
    stopOpacity: ".5"
  }), React.createElement("stop", {
    offset: "1",
    stopColor: "#C4C4C4",
    stopOpacity: "0"
  })))));
} // TODO: Using default props here as search marker relies on them.
// TODO: Codesmelly, fix later
// TODO: See src\components\search-map\SearchMarker.js:15,16


SubjectPropertyMarker.defaultProps = {
  offsetX: 0,
  offsetY: -7
};
export default SubjectPropertyMarker;